import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbCalendar, NgbDateStruct, NgbDatepickerConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PreciosService } from '@precios/precios.service';
import { BonificacionRecargo } from '@shared/models/precios/BonificacionyRecargo';

@Component({
  selector: 'app-renovar-byr',
  standalone: true,
  imports: [NgbModule, FormsModule, CommonModule],
  templateUrl: './renovar-byr.component.html',
  styleUrl: './renovar-byr.component.scss'
})
export class RenovarByrComponent implements OnInit {

  modelDesde: NgbDateStruct;
  modelHasta: NgbDateStruct;
  fechaDesde: Date;
  fechaHasta: Date;
  motivo: string = null;
  @Input() byr: BonificacionRecargo[];
  superponeFecha: boolean = false;
  errorFecha: string;
  modelHoraInicioByR: any;
  modelHoraFinByR: any;
  renovando: boolean;

  constructor(private datepickerConfig2: NgbDatepickerConfig, private calendar: NgbCalendar,
    private preciosService: PreciosService, private activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.obtenerFechaDesde();
    this.modelHasta = this.calendar.getToday();
    this.modelHoraFinByR = { hour: 23, minute: 59, second: 59 };
    const inicio: any = { day: 1, month: 1, year: 2019 };
    this.datepickerConfig2.minDate = inicio;
    const fin: any = { day: this.modelDesde.day, month: this.modelDesde.month, year: this.modelDesde.year + 1 };
    this.modelHasta = this.calendar.getToday();
    this.datepickerConfig2.maxDate = fin;
    this.superponeFecha = this.verificarSolapamientoVigencias();
  }

  renovarByR() {
    this.renovando = true;
    const byrNuevaFecha = [];
    const fechaDesde = this.formatDate(this.modelDesde.year, this.modelDesde.month, this.modelDesde.day, this.modelHoraInicioByR.hour, this.modelHoraInicioByR.minute, "00");
    const fechaHasta = this.formatDate(this.modelHasta.year, this.modelHasta.month, this.modelHasta.day, this.modelHoraFinByR.hour, this.modelHoraFinByR.minute, this.modelHoraFinByR.second);
    this.byr.forEach(byr => {
      byrNuevaFecha.push({...byr, fechaDesde: fechaDesde, fechaHasta: fechaHasta, motivo: this.motivo}) 
    });

    this.preciosService.renovarBonificacionesYRecargos(byrNuevaFecha).subscribe(() => {
      this.renovando = false;
      this.activeModal.close(true);
    }, () => {
      this.renovando = false;
      this.activeModal.close(false)
    })

  }

  obtenerFechaDesde() {
    const maxFechaHasta = this.byr
      .map(item => new Date(item.fechaHasta))
      .reduce((max, current) => (current > max ? current : max), new Date(0));

    maxFechaHasta.setMinutes(maxFechaHasta.getMinutes() + 1);

    this.modelDesde = {
      year: maxFechaHasta.getFullYear(),
      month: maxFechaHasta.getMonth() + 1,
      day: maxFechaHasta.getDate(),
    };

    this.modelHoraInicioByR = {
      hour: maxFechaHasta.getHours(),
      minute: maxFechaHasta.getMinutes(),
      second: maxFechaHasta.getSeconds(),
    };
  }

  changeModelDesde($event) {
    this.modelDesde = $event;
    this.superponeFecha = this.verificarSolapamientoVigencias();
  }

  changeModelHasta($event) {
    this.modelHasta = $event;
    this.superponeFecha = this.verificarSolapamientoVigencias();
  }

  changeModelHoraDesde($event) {
    this.modelHoraInicioByR = $event;
    this.superponeFecha = this.verificarSolapamientoVigencias();
  }

  changeModelHoraHasta($event) {
    this.modelHoraFinByR = $event;
    this.superponeFecha = this.verificarSolapamientoVigencias();
  }

  cerrarModal() {
    this.activeModal.dismiss()
  }

  verificarSolapamientoVigencias() {
    const convertirNgbDateStructAFecha = (ngbDate) => {
      return new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day);
    };
  
    const nuevaFechaDesde = convertirNgbDateStructAFecha(this.modelDesde);
    nuevaFechaDesde.setHours(this.modelHoraInicioByR.hour);
    nuevaFechaDesde.setMinutes(this.modelHoraInicioByR.minute);
  
    const nuevaFechaHasta = convertirNgbDateStructAFecha(this.modelHasta);
    nuevaFechaHasta.setHours(this.modelHoraFinByR.hour);
    nuevaFechaHasta.setMinutes(this.modelHoraFinByR.minute);
  
    if (nuevaFechaDesde > nuevaFechaHasta) {
      this.errorFecha = "La fecha y hora de inicio no puede ser superior que la final.";
      return true;
    }
  
    const fechaInvalida = this.byr.some(byr => {
      const vigenciaDesde = new Date(byr.fechaDesde);
      const vigenciaHasta = new Date(byr.fechaHasta);
  
      return (
        (nuevaFechaDesde <= vigenciaHasta && nuevaFechaDesde >= vigenciaDesde) ||
        (nuevaFechaHasta <= vigenciaHasta && nuevaFechaHasta >= vigenciaDesde) ||
        (nuevaFechaDesde <= vigenciaDesde && nuevaFechaHasta >= vigenciaHasta)
      );
    });
  
    if (fechaInvalida) {
      this.errorFecha = "Las nuevas fechas de vigencia no pueden solaparse con las anteriores.";
      return true;
    } else {
      this.errorFecha = null;
      return false;
    }
  }
  

  formatDate(year, month, day, hour, minute, seconds): string {
    return year + '-' + month.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + '-' + day.toLocaleString(undefined, { minimumIntegerDigits: 2 })
      + 'T' + hour.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + minute.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + seconds;
  }



}
